import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OptionType } from '@evinced-private/ui-common';

import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';
import { USAGE_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';

import { getWebSdkUsageData, getWebSdkUsageDataV2 } from '../services/WebSdkDashboardService';

interface IUseWebSdkUsageDataQueryParams {
	showRecentTest: boolean;
	testPeriod?: OptionType;
	searchValue?: string;
	labels?: OptionType[];
	isNewPlatformEnabled?: boolean;
}

export const useWebSdkUsageDataQuery = ({
	showRecentTest,
	testPeriod,
	searchValue,
	labels,
	isNewPlatformEnabled = false
}: IUseWebSdkUsageDataQueryParams): UseQueryResult<SummaryItem[]> => {
	const v2Query = useQuery(
		[USAGE_DATA, showRecentTest, testPeriod, searchValue, labels],
		async (): Promise<SummaryItem[]> =>
			getWebSdkUsageDataV2(showRecentTest, testPeriod, searchValue, labels),
		{
			refetchInterval: REFETCH_INTERVAL,
			enabled: isNewPlatformEnabled
		}
	);

	const originalQuery = useQuery(
		[USAGE_DATA, showRecentTest, testPeriod, searchValue, labels],
		async (): Promise<SummaryItem[]> =>
			getWebSdkUsageData(showRecentTest, testPeriod, searchValue, labels),
		{
			refetchInterval: REFETCH_INTERVAL,
			enabled: !isNewPlatformEnabled
		}
	);

	return isNewPlatformEnabled ? v2Query : originalQuery;
};
